<template>
  <div class="upload">
    <h2>Create a new song</h2>
    Name the song and upload it.
    <p>
      <input type="input" id="name" ref="name" placeholder="Name" /><br />
      <input
        type="input"
        id="bpm"
        ref="bpm"
        placeholder="Bpm (optional)"
      /><br />
      <input
        type="file"
        id="file"
        ref="file"
        v-on:change="handleFileUpload()"
      />
      <button v-if="!uploading" v-on:click="submitFile()">Create</button>
      <button v-if="uploading" disabled v-on:click="submitFile()">
        Create <b-spinner class="spinner" small></b-spinner>
      </button>
    </p>
  </div>
</template>

<style scoped lang="scss">
input {
  margin: 5px;

  &#name,
  &#bpm {
    width: 100%;
    max-width: 390px;
  }
}
.spinner {
  margin: 2px;
}
button {
  width: 90px;
}
</style>

<script>
import { db, storage, loggedInUser } from "../firebaseConfig";

export default {
  data() {
    return {
      file: "",
      uploading: false,
    };
  },

  methods: {
    async submitFile() {
      // if (!this.file) return;
      const currentUser = await loggedInUser;
      // Get name and bpm
      const name = this.$refs.name.value;
      const bpm = this.$refs.bpm.value;
      if (!name) {
        alert("Name the song you lazy cunt");
        // } else if (bpm && isNaN(bpm)) {
        //   alert('bpm should be a number')
      } else {
        this.uploading = true;
        // Create a root reference
        const storageRef = storage.ref();
        const timeStamp = new Date().getTime();
        const arr = this.file.name.split(".");
        const ext = arr[arr.length - 1];
        const fileName = timeStamp + "_" + name + "." + ext;
        const songRef = storageRef.child("songs/" + timeStamp + "/");
        // upload song
        var tags = bpm ? [bpm + "bpm"] : [];
        songRef
          .child(fileName)
          .put(this.file)
          .then((uploadsnap) => {
            // get download url
            return uploadsnap.ref.getDownloadURL().then((downloadURL) => {
              // Store in db
              return db
                .collection("songs")
                .doc(String(timeStamp))
                .set({
                  name: name,
                  active: true,
                  created: timeStamp,
                  createdBy: currentUser.displayName,
                  lastUpdated: timeStamp,
                  tags: [],
                  files: [
                    {
                      time: timeStamp,
                      url: downloadURL,
                      uploadedBy: currentUser.displayName,
                    },
                  ],
                })
                .then((dbsnap) => {
                  console.log("all ok");
                  this.$router.push({
                    name: "song",
                    params: { id: String(timeStamp) },
                  });
                });
            });
          })
          .catch((error) => {
            console.error("Error adding new song: ", error);
            this.uploading = false;
          });
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
};
</script>
